var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 15
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "de_svg__a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "de_svg__b",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#262626"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0D0D0D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "de_svg__c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F01515"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#DE0000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "de_svg__d",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFD521"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFCF00"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#de_svg__a)",
  d: "M0 0h21v15H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#de_svg__b)",
  d: "M0 0h21v5H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#de_svg__c)",
  d: "M0 5h21v5H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#de_svg__d)",
  d: "M0 10h21v5H0z"
}))));
export { SvgDe as ReactComponent };
export default __webpack_public_path__ + "3d31cf8543a8fe5d95592ba6bf974216.svg";